<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_orthograph') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_category') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.category) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.rule) }}
        game-preview-setting(v-if="parameters.rule === 'vocabularyWords'" )
            span(slot="name") {{ $i18n.t('battle.battle_battleForm_grades') }}
            span(slot="value") {{ classes }}
        game-preview-setting(v-if="parameters.rule === 'vocabularyWords'" )
            span(slot="name") {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}
            span(slot="value") {{ letters }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.mode) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_playbackSpeed') }}
            span(slot="value") {{ parameters.playbackSpeed }}
        game-preview-setting(v-if="parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting(v-if="parameters.amountOfExamples && !parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        template(v-if="parameters.dictation")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                span(slot="value")
                    | {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') }}
            span(slot="value") {{ $i18n.t(parameters.showAnswer ? 'trainer.trainer_gameFormSettingValue_onAbbreviated' : 'trainer.trainer_gameFormSettingValue_offAbbreviated')  }}
        game-preview-setting(v-if="formattedSourceText" )
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_ownText') }}
            span(slot="value") {{ formattedSourceText }}
</template>

<script>
/*eslint-disable*/
import GamePreviewSettings from './GamePreviewSettings.vue';
import GamePreviewSetting from './GamePreviewSetting.vue';
import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

export default {
    props: ['parameters', 'exerciseId', 'type'],
    mixins: [GamePreviewMixin],
    components: {
        GamePreviewSettings,
        GamePreviewSetting,
    },
    computed: {
        formattedSourceText() {
            if (!this.parameters.sourceText) return '';
            if (this.parameters.sourceText.length <= 20) {
                return this.parameters.sourceText;
            }
            return this.parameters.sourceText?.split('', 20).join('') + '...';
        },
        classes() {
            return this.parameters.chosenClasses
                .map(obj => this.$i18n.t('trainer.trainer_gameFormSetting_' + `${obj}`))
                .join('; ');
        },
        letters() {
            return this.parameters.chosenLetters.map(obj => `${obj}`).join('; ');
        },
    },
};
</script>
